<template>
  <div v-if="!loading && loadTable" id="draft-order-details">
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="vx-card mb-4">
          <div class="vx-card__header">
            <div class="vx-card__title">
              <h4>{{ $t("PartyInfo") }}</h4>
            </div>
          </div>
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body custom-tbl">
              <vs-table :data="draftOrder" ref="table">
                <template slot="thead">
                  <vs-th style="width: 15%">{{ $t("Name") }}</vs-th>
                  <vs-th style="width: 15%">{{ $t("PartyType") }}</vs-th>
                  <vs-th
                    style="width: 15%"
                    v-if="
                      draftOrder.draftOrderPartyInfoQuery.partyType ==
                      'Individual'
                    "
                  >
                    {{ $t("SocialSecurityNumber") }}
                  </vs-th>
                  <vs-th
                    style="width: 15%"
                    v-if="
                      draftOrder.draftOrderPartyInfoQuery.partyType == 'Legal'
                    "
                  >
                    {{ $t("CompanyNationalId") }}
                  </vs-th>
                  <vs-th style="width: 15%">{{ $t("PhoneNumber") }}</vs-th>
                  <vs-th style="width: 25%">{{ $t("Address") }}</vs-th>
                  <vs-th style="width: 15%">{{ $t("PostalCode") }}</vs-th>
                </template>
                <template :name="{ data }" slot-scope="{ data }">
                  <vs-tr>
                    <vs-td>
                      {{ draftOrder.draftOrderPartyInfoQuery.name }}
                    </vs-td>
                    <vs-td>
                      <span
                        v-if="
                          draftOrder.draftOrderPartyInfoQuery.partyType ==
                          'Individual'
                        "
                        >{{ $t("Individual") }}</span
                      >
                      <span
                        v-if="
                          draftOrder.draftOrderPartyInfoQuery.partyType ==
                          'Legal'
                        "
                        >{{ $t("Legal") }}</span
                      >
                    </vs-td>
                    <vs-td
                      v-if="
                        draftOrder.draftOrderPartyInfoQuery.partyType ==
                        'Individual'
                      "
                    >
                      <span
                        v-if="
                          !draftOrder.draftOrderPartyInfoQuery
                            .socialSecurityNumber
                        "
                      >
                        -
                      </span>
                      {{
                        draftOrder.draftOrderPartyInfoQuery.socialSecurityNumber
                      }}
                    </vs-td>
                    <vs-td
                      v-if="
                        draftOrder.draftOrderPartyInfoQuery.partyType == 'Legal'
                      "
                    >
                      <span
                        v-if="
                          !draftOrder.draftOrderPartyInfoQuery.companyNationalId
                        "
                      >
                        -
                      </span>
                      {{
                        draftOrder.draftOrderPartyInfoQuery.companyNationalId
                      }}
                    </vs-td>
                    <td
                      v-for="item in draftOrder.draftOrderPartyInfoQuery
                        .phonesQuery"
                      :key="item.id"
                      style="direction: ltr"
                    >
                      <span v-if="item.area">{{ item.area }}-</span>
                      {{ item.number }}
                    </td>
                    <td
                      v-for="item in draftOrder.draftOrderPartyInfoQuery
                        .addressesInfosQuery"
                      :key="item.id"
                    >
                      {{ item.provinceInfo.name }}-{{
                        item.provinceInfo.cityName
                      }}-{{ item.address }}
                    </td>
                    <td
                      v-for="item in draftOrder.draftOrderPartyInfoQuery
                        .addressesInfosQuery"
                      :key="item.id"
                    >
                      {{ item.postalCode }}
                    </td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="vx-card mb-4">
          <div class="vx-card__header">
            <div class="vx-card__title w-full">
              <h4>
                {{ $t("OrdersList") }}
                <span v-if="saleType == 'B2C'">
                  {{ $t("From") }}
                  {{ $t("Contract") }}:
                </span>
                <span class="color-primary" v-if="saleType == 'B2C'">{{
                  draftOrder.draftOrderContractQuery.contractTitle
                }}</span>
                <span class="date float-right">
                  <span> {{ $t("CreateOn") }}: </span>
                  <span class="float-right">
                    {{ draftOrder.createOn }}
                  </span>
                </span>
              </h4>
            </div>
          </div>
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body custom-tbl" id="draft-order-tbl">
              <vs-table :data="draftOrder.draftOrdersItemsQueryDto" ref="table">
                <template slot="thead">
                  <vs-th style="width: 3%">#</vs-th>
                  <vs-th style="width: 17%">{{ $t("ProductName") }}</vs-th>
                  <vs-th style="width: 8%">{{ $t("ItemCode") }}</vs-th>
                  <vs-th style="width: 5%">{{ $t("Count") }}</vs-th>
                  <vs-th style="width: 11%">{{ $t("UnitPrice") }}</vs-th>
                  <vs-th style="width: 11%">{{ $t("TotalAmount") }}</vs-th>
                  <vs-th style="width: 11%">{{ $t("SumOfDiscount") }}</vs-th>
                  <vs-th style="width: 11%">{{
                    $t("TotalAmountAfterDeductionOfDiscounts")
                  }}</vs-th>
                  <vs-th style="width: 11%">{{ $t("TotalTaxAmount") }}</vs-th>
                  <vs-th style="width: 12%">{{
                    $t("TotalAmountWithTax")
                  }}</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    v-for="(tr, indextr) in data"
                    :data="tr"
                    :key="indextr"
                  >
                    <vs-td :data="data[indextr]">
                      {{ parseInt(indextr) + 1 }}
                    </vs-td>
                    <vs-td
                      :data="
                        data[indextr].draftOrderProductInfoQuery.productName
                      "
                    >
                      {{ data[indextr].draftOrderProductInfoQuery.productName }}
                    </vs-td>
                    <vs-td
                      :data="data[indextr].draftOrderProductInfoQuery.itemCode"
                    >
                      {{ data[indextr].draftOrderProductInfoQuery.itemCode }}
                    </vs-td>
                    <vs-td :data="data[indextr].count">
                      {{ data[indextr].count }}
                    </vs-td>
                    <vs-td :data="data[indextr].unitPrice">
                      {{ Number(data[indextr].unitPrice).toLocaleString() }}
                      ریال
                    </vs-td>
                    <vs-td :data="data[indextr].totalAmount">
                      {{ Number(data[indextr].totalAmount).toLocaleString() }}
                      ریال
                    </vs-td>
                    <vs-td :data="data[indextr].sumOfDiscount">
                      <span v-if="data[indextr].sumOfDiscount">
                        {{
                          Number(data[indextr].sumOfDiscount).toLocaleString()
                        }}
                        ریال
                      </span>
                      <span v-else> 0 </span>
                    </vs-td>
                    <vs-td
                      :data="data[indextr].totalAmountAfterDeductionOfDiscounts"
                    >
                      {{
                        Number(
                          data[indextr].totalAmountAfterDeductionOfDiscounts
                        ).toLocaleString()
                      }}
                      ریال
                    </vs-td>
                    <vs-td :data="data[indextr].totalTaxAmount">
                      {{
                        Number(data[indextr].totalTaxAmount).toLocaleString()
                      }}
                      ریال
                    </vs-td>
                    <vs-td :data="data[indextr].price">
                      {{ Number(data[indextr].price).toLocaleString() }} ریال
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <h6 class="text-left shipping-fee">
                {{ $t("ShippingFee") }}:
                {{ Number(draftOrder.shippingFee).toLocaleString() }} ریال
              </h6>
              <h5 class="text-left total-price">
                {{ $t("TotalAmountForPayment") }}:
                {{ Number(draftOrder.totalAmountForPayment).toLocaleString() }}
                ریال
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col lg:w-1/2 sm:w-1/2 w-full">
        <div class="vx-card mb-4">
          <div class="vx-card__header">
            <div class="vx-card__title w-full">
              <h4 class="d-inline float-left">{{ $t("OrderInfo") }}</h4>
              <vs-chip
                transparent
                color="warning"
                class="float-right hide-in-print"
              >
                <span v-if="draftOrder.orderState == 'PendingState'">{{
                  $t("Pending")
                }}</span>
                <span v-if="draftOrder.orderState == 'ConfirmState'">{{
                  $t("Confirmed")
                }}</span>
                <span v-if="draftOrder.orderState == 'RejectState'">{{
                  $t("Rejected")
                }}</span>
              </vs-chip>
            </div>
          </div>
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body custom-tbl v-table">
              <vs-table :data="tableBasketData" ref="orderTable">
                <template slot-scope="{ data }">
                  <vs-tr>
                    <vs-td>
                      {{ $t("OrderNumber") }}
                    </vs-td>
                    <vs-td>
                      {{ siteOrderNumber }}
                    </vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      {{ $t("TotalAmount") }}
                    </vs-td>
                    <vs-td>
                      {{ Number(data.sumOfFinalPrice).toLocaleString() }} ریال
                    </vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      {{ $t("ShippingFee") }}
                    </vs-td>
                    <vs-td>
                      {{ Number(data.shippingFee).toLocaleString() }} ریال
                    </vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      {{ $t("ToPay") }}
                    </vs-td>
                    <vs-td>
                      {{ Number(data.totalAmount).toLocaleString() }} ریال
                    </vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      {{ $t("PaymentStatus") }}
                    </vs-td>
                    <vs-td>
                      <span v-if="data.paymentType == 1">
                        {{ $t("CreditPayment") }}
                      </span>
                      <span v-if="data.paymentType == 2">
                        {{ $t("OnlinePayment") }}
                      </span>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-col lg:w-1/2 sm:w-1/2 w-full">
        <div class="vx-card mb-4">
          <div class="vx-card__header">
            <div class="vx-card__title">
              <h4>{{ $t("PaymentInfo") }}</h4>
            </div>
          </div>
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div
              class="vx-card__body custom-tbl v-table"
              v-bind:class="{ customheight: showMore }"
            >
              <vs-table
                :data="tableBasketData.payments"
                ref="paymentTable"
                id="order-payment-tbl"
              >
                <template slot-scope="{ data }">
                  <span v-for="(tr, indextr) in data" :key="indextr">
                    <vs-tr>
                      <vs-td>
                        {{ $t("PaymentGateway") }}
                      </vs-td>
                      <vs-td :data="data[indextr].bankType">
                        <span v-if="data[indextr].bankType == 1">ملت</span>
                        <span v-else-if="data[indextr].bankType == 2">ملی</span>
                        <span v-else-if="data[indextr].bankType == 3"
                          >مسکن</span
                        >
                        <span v-else-if="data[indextr].bankType == 4">سپه</span>
                        <span v-else-if="data[indextr].bankType == 5"
                          >پاسارگاد</span
                        >
                        <span v-else-if="data[indextr].bankType == 6"
                          >پارسیان</span
                        >
                        <span v-else-if="data[indextr].bankType == 7"
                          >ایران خودرو</span
                        >
                        <span v-else>متفرقه</span>
                      </vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td>
                        {{ $t("ReceiptNumber") }}
                      </vs-td>
                      <vs-td>
                        <span :data="data[indextr].referenceId">
                          {{ data[indextr].referenceId }}
                        </span>
                      </vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td>
                        {{ $t("Date") }}
                      </vs-td>
                      <vs-td style="direction: ltr">
                        <div v-if="tableBasketData.paymentType == 1">
                          {{ basket.actionTime }}
                        </div>
                        <div
                          v-if="
                            tableBasketData.payments &&
                            tableBasketData.paymentType == 2
                          "
                        >
                          {{ data[indextr].referenceTime }}
                        </div>
                      </vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td>
                        {{ $t("Fee") }}
                      </vs-td>
                      <vs-td :data="data[indextr].amount">
                        {{ Number(data[indextr].amount).toLocaleString() }} ریال
                      </vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td>
                        {{ $t("Status") }}
                      </vs-td>
                      <vs-td>
                        <span v-if="data[indextr].state == 1">{{
                          $t("Create")
                        }}</span>
                        <span v-if="data[indextr].state == 2">{{
                          $t("Token")
                        }}</span>
                        <span v-if="data[indextr].state == 3">{{
                          $t("CallBackFromBank")
                        }}</span>
                        <span v-if="data[indextr].state == 4">{{
                          $t("Confirm")
                        }}</span>
                        <span v-if="data[indextr].state == 5">{{
                          $t("Reject")
                        }}</span>
                      </vs-td>
                    </vs-tr>
                  </span>
                </template>
              </vs-table>
              <vs-button
                type="button"
                :icon="showMore ? 'expand_more' : 'expand_less'"
                class="read-more-btn hide-in-print"
                v-show="loadBtn && tableBasketData.payments.length > 1"
                @click="showMore = !showMore"
              >
                {{ showMore ? "مشاهده بیشتر" : "مشاهده کم‌تر" }}
              </vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="vx-row" v-if="loadTable">
      <div class="vx-col w-full">
        <vs-button
          v-if="draftOrder.orderState == 'PendingState'"
          type="button"
          class="float-right ml-4 reject-btn"
          @click.prevent="rejectDraftOrer(draftOrder.id)"
          :disabled="disabledReject"
          v-has-permission="permission1"
          >{{ $t("DraftOrderRejected") }}</vs-button
        >
        <router-link
          :to="{ path: '/DraftOrders/Invoice/' + draftOrder.id }"
          class="vs-button purple float-right pb-4 ml-3 mt-0"
          v-has-permission="permission"
        >
          {{ $t("Invoice") }}
        </router-link>
      </div>
    </div> -->
  </div>
</template>
<style>
.vs-table--tbody-table {
  min-width: 240px !important;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import "@/assets/scss/vuesax-rtl/pages/_webOrderdetails.scss";
export default {
  name: "saleManagement_DraftOrders_Details",
  data() {
    return {
      permission1: "ChangeDischargePermissionStateToConfirm",
      permission: "GetAllDraftOrderById",
      loadTable: false,
      disabled: false,
      disabledReject: false,
      siteOrderNumber: "",
      saleType: "",
      tableBasketData: [],
      loadBtn: false,
      showMore: true,
    };
  },
  computed: {
    ...mapGetters({
      draftOrder: "draftOrder/details",
      agnetBasket: "basket/agentBasketDetails",
      loading: "draftOrder/loading",
      basket: "basket/details",
      agentBasketDetails: "basket/agentBasketDetails",
    }),
  },
  mounted() {
    this.saleType = this.$route.query.saleType;
    this.load();
    setTimeout(() => {
      this.loadTable = true;
    }, 100);
  },
  methods: {
    ...mapActions({
      fetchDraftOrder: "draftOrder/fetchSingle",
      fetchSaleAgentBasket: "basket/fetchSaleAgentBasket",
      fetchBasketInfo: "basket/fetchSingle",
      // patchDraftOrder: "draftOrder/patch"
    }),
    load() {
      var id = this.$route.params.id;
      if (this.saleType == "B2C") {
        this.fetchDraftOrder(id).then(() => {
          this.fetchBasketInfo(this.draftOrder.basketId).then(() => {
            this.siteOrderNumber = "APO-" + this.basket.id;
            this.tableBasketData = this.basket;
            if (this.tableBasketData.payments.length > 1) {
              this.loadBtn = true;
            } else {
              this.loadBtn = false;
            }
          });
        });
      } else if (this.saleType == "B2B") {
        this.fetchDraftOrder(id).then(() => {
          this.fetchSaleAgentBasket(this.draftOrder.basketId).then(() => {
            // var basketIdFormat = ("0000" + this.agentBasketDetails.id).substr(
            //   -4
            // );
            this.siteOrderNumber = "APO-" + this.agentBasketDetails.id;
            this.tableBasketData = this.agentBasketDetails;
            if (this.tableBasketData.payments.length > 1) {
              this.loadBtn = true;
            } else {
              this.loadBtn = false;
            }
          });
        });
      }
    },
    // rejectDraftOrer(id) {
    //   (async () => {
    //     const { value: reasonOfReject } = await this.$swal({
    //       input: "textarea",
    //       inputLabel: "Message",
    //       title: "آیا از رد این پیش فاکتور اطمینان دارید؟",
    //       inputPlaceholder: "علت رد پیش فاکتور...",
    //       inputAttributes: {
    //         required: true
    //       },
    //       showCancelButton: true,
    //       confirmButtonColor: "#3085d6",
    //       cancelButtonColor: "#d33",
    //       confirmButtonText: "ثبت",
    //       cancelButtonText: "بستن"
    //     });
    //     if (reasonOfReject) {
    //       this.disabledReject = true;
    //       this.patchDraftOrder({ reasonOfReject, id }).then(() => {
    //         this.$swal({
    //           position: "center-center",
    //           type: "success",
    //           text: "پیش فاکتور مورد‌نظر رد شد!",
    //           showConfirmButton: false,
    //           timer: 2000
    //         }).then(() => {
    //           this.$router.push("/DraftOrders/Index");
    //         });
    //       });
    //       this.disabledReject = false;
    //     }
    //   })();
    // }
  },
  beforeRouteLeave(to, from, next) {
    if (to.path === "/DraftOrders/Index") {
      if (to.query.state) {
        delete to.query.state;
      }
      if (this.draftOrder.orderState) {
        Object.assign(to.query, { state: this.draftOrder.orderState });
      }
      return next();
    } else {
      return next();
    }
  },
};
</script>
